import { ReviewResult } from './check';

export enum Review {
  style = 'styleReview',
  safety = 'safetyReview',
  claims = 'claimsReview',
  branding = 'brandingReview',
}

export enum DocumentCategory {
  brandingReview = 'brandingReview',
  ssiCompleteness = 'ssiCompleteness',
}

export type StatisticsByCategory = {
  all: number;
  [ReviewResult.fail]: number;
  [ReviewResult.pass]: number;
  [ReviewResult.warning]: number;
};

export type StatisticsByPage = {
  [Review.style]: StatisticsByCategory;
  [Review.safety]: StatisticsByCategory;
  [Review.claims]: StatisticsByCategory;
  [Review.branding]: StatisticsByCategory;
};

export type StatisticByStatus = {
  [ReviewResult.fail]: number;
  [ReviewResult.pass]: number;
  [ReviewResult.warning]: number;
};

export const COUNTABLE_STATS_CATEGORIES: (
  | Review.safety
  | Review.style
  | Review.claims
)[] = [Review.safety, Review.style, Review.claims];
